<template>
  <div>
    <el-dialog
      :title="`请选择图片质量(${(quality).toFixed(2)}MB)`"
      width="300px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible="warnDialog"
      :btns="warnbtns">
      <el-radio-group v-model="quality">
        <el-radio :label="1">原图</el-radio>
        <el-radio :label="0.8">高清</el-radio>
        <el-radio :label="0.4">普通</el-radio>
      </el-radio-group>
      <div slot="footer" style="text-align:center">
        <el-button  type="text" @click="handleNever">不再提醒</el-button>
        <el-button type="primary" @click="handleConfrim">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      qualitys: [
        {
          value: 1,
          text: '原图'
        },
        {
          value: 0.8,
          text: '高清'
        },
        {
          value: 0.4,
          text: '普通'
        }
      ],
      quality: localStorage.quality && localStorage.quality !== 'undefined' ? +localStorage.quality : 1,
      uploadWarning: localStorage.uploadWarning && localStorage.uploadWarning !== 'undefined' ? +localStorage.uploadWarning : 1,
      hasWarned: localStorage.hasWarned && localStorage.hasWarned !== 'undefined' ? +localStorage.hasWarned : 0,
      warnDialog: false
    }
  },
  methods: {
    handleNever() {
      localStorage.uploadWarning = 0
      this.uploadWarning = 0
      localStorage.hasWarned = 1
      localStorage.quality = this.quality
      this.warnDialog = false
      this.callback && this.callback()
    },
    handleConfrim() {
      localStorage.hasWarned = 1
      localStorage.quality = this.quality
      this.warnDialog = false
      this.callback && this.callback()
    },
    openConfirm() {
      this.warnDialog = true
    }
  }
}
</script>
